
import {
  handleRequestPort,
  getWriter,
  getPort,
  getReader,
  setSerialState,
  getSerialState, clearPort
} from './mySerialUtils.js'
import { Message } from '@/utils/Message'

let res = ''
/* =====================打印二维码 #start===================== */
// 打开串口async
export const openSerial = async(baudRate) => {
  if (!getSerialState()) {
    try {
      await handleRequestPort(baudRate)
      // 设置串口处于打开状态
      setSerialState(true)
      console.log('串口授权成功')
    } catch (e) {
      console.log(e)
      console.log('串口授权异常')
    }
  } else {
    // console.log('串口已授权并处于打开状态')
  }
}

// 关闭串口
export const closeSerial = async() => {
  if (getSerialState()) {
    const writer = getWriter()
    const reader = getReader()
    const port = getPort()
    await writer.close()
    // await reader.close()
    await port.close()
    // 将串口设置为关闭状态
    setSerialState(false)
    console.log('串口关闭成功')
  } else {
    console.log('串口处于关闭状态，请重新授权串口')
  }
}

export const readerData = async(jiaoyan) => {
  const list = ['']
  if ('serial' in navigator) {
    // console.log('The Web Serial API is supported.')
  }
  if (getSerialState()) {
    try {
      res = ''
      while (getPort().readable) {
        const { value } = await getReader().read()
        value.map(item => {
          const charCode = String.fromCharCode(item)
          if ((item === 13 || item === 10) && list[list.length - 1].length > 2) { // 有换行，添加一条数据
            list.push('')
          } else {
            list[list.length - 1] += charCode
          }
        })
        jiaoyan = jiaoyan || 30
        if (list[0].length > jiaoyan) {
          let number = list[0]
          console.log('number..', number)
          const regex = /\x03\x02(.*?)(?=\x03\x02)/g
          // 提取 n1 中的数字
          const matches1 = []
          let match
          while ((match = regex.exec(number)) !== null) {
            if (match[1].length > 3) {
              matches1.push(match[1]) // match[1] 是捕获组中的数字部分
            }
          }
          console.log('number..', matches1)
          if (matches1.length > 0) {
            number = matches1[0].substring(0, matches1[0].length - 3)
            // 返回数据
            return parseFloat(number)
          }
          return 0
        }
      }
    } catch (e) {
      console.log(e)
    } finally {
      // console.log("read end")
      res = ''
      getReader().releaseLock()
    }
  } else {
    clearPort()
    return Promise.resolve({ code: 1, data: '当前串口无法连接，请刷新页面重试' })
  }
}

// 预计每个数字都返回，用回车、换行，拆分数据，
export const readerDataSync = async(jiaoyan, callback) => {
  const list = ['']
  if ('serial' in navigator) {
    // console.log('The Web Serial API is supported.')
  }
  if (getSerialState()) {
    try {
      res = ''
      while (getPort().readable) {
        const { value } = await getReader().read()
        value.map(item => {
          const charCode = String.fromCharCode(item)
          if ((item === 13 || item === 10) && list[list.length - 1].length > 2) { // 有换行，添加一条数据
            list.push('')
          } else {
            list[list.length - 1] += charCode
          }
        })
        jiaoyan = jiaoyan || 30
        if (list[0].length > jiaoyan) {
          let number = list[0]
          const regex = /\x03\x02(.*?)(?=\x03\x02)/g
          // 提取 n1 中的数字
          const matches1 = []
          let match
          while ((match = regex.exec(number)) !== null) {
            if (match[1].length > 3) {
              matches1.push(match[1]) // match[1] 是捕获组中的数字部分
            }
          }
          if (matches1.length > 0) {
            number = matches1[0].substring(0, matches1[0].length - 3)
            // 返回数据
            callback(parseFloat(number))
          }
          list.shift()
          list.shift()
          break
        }
      }
    } catch (e) {
      console.log('readerDataSync error' + e)
    } finally {
      res = ''
      getReader().releaseLock()
    }
  } else {
    clearPort()
    Message.warning('当前串口无法连接，请刷新页面重试')
  }
}
